<script setup>
const props = defineProps({
    class: { type: String, default: 'my-6' },
});
</script>

<template>
    <hr :class="props.class" class="w-full border-solid border-top-1 border-bottom-none surface-border">
</template>